var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmacyPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 29.99",
    style: {
      enableBackground: "new 0 0 20 29.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,10c0,5.52-10,19.38-10,19.38S0,15.52,0,10S4.48,0,10,0S20,4.48,20,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.51,4.34C7,4.34,7.4,3.94,7.4,3.45S7,2.55,6.51,2.55s-0.89,0.4-0.89,0.89S6.01,4.34,6.51,4.34z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,2.33c-1.15,0-2.36,0.26-3.33,0.73C6.49,3.14,6.41,3.36,6.5,3.54C6.58,3.71,6.8,3.79,6.98,3.7 C7.85,3.29,8.95,3.05,10,3.05c3.75,0,6.91,3.16,6.91,6.91s-3.16,6.91-6.91,6.91S3.09,13.7,3.09,9.96c0-1.71,0.63-3.4,1.72-4.63 c0.13-0.15,0.12-0.37-0.03-0.51C4.63,4.69,4.41,4.71,4.28,4.85c-1.21,1.36-1.9,3.22-1.9,5.1c0,4.14,3.48,7.63,7.63,7.63 c4.14,0,7.63-3.48,7.63-7.63C17.63,5.81,14.15,2.33,10,2.33z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.43,5.3H8.57c-0.2,0-0.36,0.16-0.36,0.36v2.51H5.7c-0.2,0-0.36,0.16-0.36,0.36v2.86 c0,0.2,0.16,0.36,0.36,0.36h2.51v2.51c0,0.2,0.16,0.36,0.36,0.36h2.86c0.2,0,0.36-0.16,0.36-0.36v-2.51h2.51 c0.2,0,0.36-0.16,0.36-0.36V8.53c0-0.2-0.16-0.36-0.36-0.36h-2.51V5.66C11.79,5.46,11.63,5.3,11.43,5.3z M13.94,8.88v2.15h-2.51 c-0.2,0-0.36,0.16-0.36,0.36v2.51H8.93v-2.51c0-0.2-0.16-0.36-0.36-0.36H6.06V8.88h2.51c0.2,0,0.36-0.16,0.36-0.36V6.02h2.15v2.51 c0,0.2,0.16,0.36,0.36,0.36H13.94z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacyPin);
export default __webpack_public_path__ + "static/media/pharmacy-pin.1e2b68dc.svg";
export { ForwardRef as ReactComponent };